import { render, staticRenderFns } from "./MasonryCategoryMenu.vue?vue&type=template&id=648ac465&scoped=true"
import script from "./MasonryCategoryMenu.vue?vue&type=script&lang=js"
export * from "./MasonryCategoryMenu.vue?vue&type=script&lang=js"
import style0 from "./MasonryCategoryMenu.vue?vue&type=style&index=0&id=648ac465&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648ac465",
  null
  
)

export default component.exports